import { Text } from '@/ui-components/atoms/Text/Text';
import styles from './sportstrip.module.scss';
import { Race } from '@/packages/sxm/sports/races/RacesResponse';
import { Button } from '@/ui-components/atoms/Button/Button';

interface Props {
    drivers: Race[];
}

export default function DriverStrip({ drivers }: Props): React.JSX.Element {
    return (
        <div className={styles.driverStripContainer}>
            <Text tag="div" variant="text-small" className={styles.driverHeader}>
                DRIVER CHANNELS
            </Text>
            <div className={styles.driversStrip}>
                {drivers.map((driver, i) => (
                    <Text key={i} tag="div" className={styles.driver}>
                        <span>{driver.raceOrDriverName}</span>
                        {driver.nationalInternetStream && driver.nationalStreamLink ? (
                            <Button
                                type="button"
                                variant="secondary"
                                fitting="hug-contents"
                                href={driver.nationalStreamLink}
                                size="small"
                                className={styles.channelLink}
                            >
                                CH {driver.nationalInternetStream}
                            </Button>
                        ) : (
                            <span>CH {driver.nationalInternetStream || driver.nationalStream}</span>
                        )}
                    </Text>
                ))}
            </div>
        </div>
    );
}
